"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4 1a.5.5 0 0 1 .41.213l3.5 5a.5.5 0 1 1-.82.574L14 12.372l-3.09 4.415a.5.5 0 1 1-.82-.574l.67-.957-1.262-1.486-2.618 3.055a.5.5 0 1 1-.76-.65l3-3.5a.5.5 0 0 1 .761.001l1.472 1.734 2.237-3.197A.5.5 0 0 1 14 11"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5.5 5A1.5 1.5 0 0 0 4 6.5v11A1.5 1.5 0 0 0 5.5 19h13a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 18.5 5zM5 6.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5z"
  })]
}), 'ImageBlank');
//# sourceMappingURL=index.js.map